import api from "@/services/api";
import type {
	ExpensesHistoryPaginatedResponse,
	ExpensesHistoryPeriod,
} from "../types";

export async function getExpensesHistory(params: ExpensesHistoryPeriod) {
	const { startDate, endDate, pageNumber, pageSize, plate, types } = params;

	const searchParams = new URLSearchParams({
		startDate,
		endDate,
		pageNumber: String(pageNumber),
		pageSize: String(pageSize),
	});

	if (plate) {
		searchParams.append("plate", plate);
	}

	if (types?.length) {
		for (const typeCode of types) {
			searchParams.append("types", String(typeCode));
		}
	}

	const { data } = await api.get<ExpensesHistoryPaginatedResponse>(
		"/api/expenses/history",
		{
			params: searchParams,
		}
	);
	return data;
}
